const CATEGORY_TIPS = {
  ethnic: {
    wear: "Office (with dupatta draped), family lunch, festive gatherings",
    pair: "Palazzo or straight pants, juttis, light jhumkas",
    avoid: "Beach holidays or very casual sportswear",
  },
  coords: {
    wear: "Brunch, travel days, casual office, weekend errands",
    pair: "Flat sandals, minimal gold hoops, a structured tote",
    avoid: "Black-tie evenings or heavy formal events",
  },
  dresses: {
    wear: "Date night, resort dinners, daytime events, Sunday lunch",
    pair: "Strappy heels or kolhapuris, a soft clutch, delicate earrings",
    avoid: "High-intensity outdoor activities",
  },
  tops: {
    wear: "Office, coffee dates, layered under blazers or co-ords",
    pair: "High-rise jeans, linen trousers, pearl studs",
    avoid: "Formal evening wear on their own",
  },
};

const COLOR_PAIRINGS = {
  ivory: "cream palazzo, tan juttis, pearl studs",
  cream: "white trousers, gold hoops, nude flats",
  sand: "linen pants, brown sandals, woven bag",
  olive: "beige culottes, tan kolhapuris, brass bangles",
  rose: "soft white pants, nude heels, rose-gold earrings",
  espresso: "ivory bottoms, gold jhumkas, block heels",
  charcoal: "white or cream bottoms, silver jewellery",
  stone: "neutral trousers, minimal sandals",
  camel: "white or ecru layers, tan accessories",
};

const pickColorPairing = (color = "") => {
  const key = Object.keys(COLOR_PAIRINGS).find((k) => color.toLowerCase().includes(k));
  return key ? COLOR_PAIRINGS[key] : "neutral bottoms, minimal jewellery, comfortable flats";
};

/** Category-based styling suggestions — no AI required. */
export const getStylingTips = (product) => {
  const base = CATEGORY_TIPS[product?.category] || CATEGORY_TIPS.tops;
  return {
    wear: base.wear,
    pair: `${pickColorPairing(product?.color)} — ${base.pair.split(",")[0]}`,
    avoid: base.avoid,
  };
};
